import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';

import { InfoField, ChipBox } from '@occc-app/design-system';
import { AwardProductDiscountFragment } from '@occc/graphql';

interface IProductDiscountProps {
  award: AwardProductDiscountFragment;
}

const formatPurchaseThreshold = ({
  purchaseThreshold,
}: {
  purchaseThreshold: AwardProductDiscountFragment['purchaseThreshold'];
}): string => `${purchaseThreshold}`;

export const ProductDiscountAward: React.FC<IProductDiscountProps> = ({ award }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField
          label='Included Product Groups'
          value={<ChipBox items={award.eligibleProductGroups} onClick={onChipClick} mt={0} />}
          disableTypography
        />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Percent Discount' value={award?.percentDiscount} />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Purchase Threshold' value={formatPurchaseThreshold(award)} />
      </Grid>
    </Grid>
  );
};
